// @flow weak

import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import Chart          from 'chart.js';
import FilterableTable from 'react-filterable-table';
import $ from 'jquery'
var Spinner = require('react-spinkit');
import {
  earningGraphMockData
}                     from '../../models';
import Panel          from '../panel/Panel';
import WorkProgressPanel  from '../../components/workProgress/workProgressPanel/WorkProgressPanel';
import fetchStatsTableDataIfNeeded  from '../../redux/modules/actions';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol,
  SmallTableHeader,
}                         from '../../components';
import {store} from '../../Root.js'
import TableData from '../../components/table/tableCol/TableData'
import {CSVLink, CSVDownload} from 'react-csv';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import DatePicker from 'react-datepicker';
import moment     from 'moment';


class StatsTable extends Component {

  // chart = null;
  // linechart = null;

  constructor(props) {
    super(props);
    var defaultExpanded = false;
    if(this.props.nonCollapsible){
      defaultExpanded = true
    }
    this.state        = { selectedLocation: props.selectedLocation, expanded: defaultExpanded, selectedDate: moment().subtract( 1, 'day' ),end_date: moment() } ;
    this.refreshTable = this.refreshTable.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
  }



  componentDidMount() {
    // const { headers, data } = this.props;
    // if(!this.props.nonCollapsible){
    //   $('.collapsibile-table-heading').trigger("click");      
    // }


    $("#"+this.props.name).on('show.bs.collapse', function(){
      this.setState({expanded : true});
      // console.log('The collapsible content is about to be shown.');
    }.bind(this));

    $("#"+this.props.name).on('hidden.bs.collapse', function(){
      this.setState({expanded : false});
      // console.log('The collapsible content is about to be shown.');
    }.bind(this));

  }

  componentWillReceiveProps(newProps) {
    const tableData = newProps.data[newProps.name]
    const { isFetching, requested_venue_id, venue_id } = tableData;
    if(!isFetching){
      if(requested_venue_id != venue_id){
        if(this.state.expanded){
          console.log('Reload required');
          this.props.reloadData(requested_venue_id,this.props.name);
        }else{
          console.log('The table is not visible. So not fetching data.');
        }        
        
      }
    }
  }


  componentWillUnmount() {
    console.log("I am unmounting " + this.props.name);
    const tableData = this.props.data[this.props.name]
    const { headers, data, isFetching, requested_venue_id, venue_id } = tableData;
    if (data.length>100){
      console.log("I am fat table, so clearing: " + data.length);
      this.props.reloadData(-1,this.props.name);
    }
  }


  handleDateChange(date){
    this.setState({selectedDate: date},function () {
      this.refreshTable();
    });
    
    
  }

  handleEndDateChange(date){
    this.setState({end_date: date},function () {
      this.refreshTable();
    });
  }

  // componentDidUpdate(prevProps, prevState){
  //   $('span.row-danger').closest('tr').addClass('danger-row');
  // }

  bigTable(data,headers,name){
    //Convert data to react-filterable-table format
    var cols = headers;
    const dataTableData = data.map(function(element,index){
       var newObj = {};
       element.forEach(function(data,index){
          newObj[cols[index]]=data;
       });
       return newObj;
    });
    //Convert headers to react-filterable-table format.
    // var headings = [];
    const headings = headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = element;//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

  return <ReactTable
            data={dataTableData}
            columns={headings}
            showPagination={data.length>100}
            showPaginationTop={data.length>100}
            defaultPageSize={100}
            minRows={0}
            filterable={true}
            defaultFilterMethod= {(filter, row, column) => {
              const id = filter.pivotId || filter.id
              return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
            }}  
            getTrProps={(state, rowinfo, column) => {
              var bgcolor = '#dcdcdc';
              if (rowinfo!=undefined && rowinfo.row.hasOwnProperty("style_hidden")) {
                  var row_style = rowinfo.row["style_hidden"]
                  if(row_style!=null && row_style.indexOf('row-danger') != -1){
                    bgcolor = '#FFC8B8';
                  }else if(row_style!=null && row_style.indexOf('row-warning') != -1){
                    bgcolor = '#FFE699';
                  }
              }              
              return {
                style: {
                  background: bgcolor
                }
              };
            }}                     
          >{
              //To show the record count on top  
              (state, makeTable, instance) => {
                let recordsInfoText = "";

                const { filtered, pageRows, pageSize, sortedData, page } = state;

                if (sortedData && sortedData.length > 0) {
                  let isFiltered = filtered.length > 0;

                  let totalRecords = sortedData.length;

                  let recordsCountFrom = page * pageSize + 1;

                  let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                  if (isFiltered)
                    // recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
                    recordsInfoText = `${totalRecords} filtered records`;
                  else
                    // recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
                    recordsInfoText = `${totalRecords} records`;
                } else recordsInfoText = "No records";

                return (
                  <div className="main-grid">
                    <div className="above-table text-right">
                      <div className="col-sm-12 records-info">
                        <span className="">{recordsInfoText}</span>
                      </div>
                    </div>

                    {makeTable()}
                  </div>
                );
              }
            }</ReactTable>;
  }

  smallTable(data,headers,name, displayName, color){
    return(
      <div>
        <div className={this.props.nonCollapsible?"":"collapsibile-table-heading"} data-toggle={this.props.nonCollapsible?"":"collapse"} style={{cursor: 'pointer'}} href={"#"+this.props.name}>
          <SmallTableHeader name={displayName} color={color}></SmallTableHeader>
        </div>
        <div id={this.props.name} className={this.props.nonCollapsible?"":"collapse"}>
          <Table>
            <TableHeader>
              {
                headers.map(
                  (header, headerIdx) => {
                    return (
                      <th key={headerIdx}>
                        {header}
                      </th>
                    );
                  }
                )
              }
            </TableHeader>
            <TableBody>
              {
                data.map(
                  (contentRow, contentRowIdx) => {
                    return (
                      <TableRow key={contentRowIdx}>
                        {
                          contentRow.map(
                            (contentColumn, contentColumnIdx) => {
                              return (
                                <TableCol key={contentColumnIdx}>
                                  {contentColumn}
                                </TableCol>
                              );
                            }
                          )
                        }
                      </TableRow>
                    );
                  }
                )
              }
            </TableBody>
          </Table>
        </div>
      </div>
        ) ;
  }

  refreshTable(){
    console.log('refreshTable');
    const tableData = this.props.data[this.props.name];
    const { headers, data, isFetching, requested_venue_id, venue_id,game_type_id } = tableData;
    this.props.reloadData(requested_venue_id,this.props.name,this.props.game_type_id,{"selectedDate":moment(this.state.selectedDate).format("YYYY-MM-DD"),"end_date":moment(this.state.end_date).format("YYYY-MM-DD")});
  }


  render() {
    // console.log("rendering");
    const tableData = this.props.data[this.props.name]
    const { headers, data, isFetching, requested_venue_id, venue_id,game_type_id } = tableData;
    //TODO - This is anti-pattern and risky.
    // console.log("Current gametype: " + game_type_id);
    // console.log("Requested:" + this.props.game_type_id);


    var reloadRequired = false;

    if(!isFetching){
      if(requested_venue_id != venue_id ){ //Venue changed.
        reloadRequired = true;
      }
      if(!reloadRequired){
        if(this.props.game_type_id != undefined && this.props.game_type_id != game_type_id){
          reloadRequired = true;
        }
      }
    }
    // console.log("Reload required: ");
    // console.log(reloadRequired);
    if(reloadRequired){
      if(this.state.expanded){
        console.log('Reload required');
        this.refreshTable();
        // this.props.reloadData(requested_venue_id,this.props.name,this.props.game_type_id);  
      }else{
        console.log('The table is not visible. So not fetching data.');
      }
      
    }

    var loaderDiv;
    if (isFetching) {
      loaderDiv = <div className="loading-overlay"><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>;
    } else {
      loaderDiv = null;

    }

    var csvData = [];
    csvData[0] = headers;
    csvData = csvData.concat(data);

    return (
      <WorkProgressPanel>
        {loaderDiv}

        { this.props.bigTable &&
          <div>
            <div>
              <div className={this.props.nonCollapsible?"":"collapsibile-table-heading"} style={{cursor: 'pointer'}} data-toggle={this.props.nonCollapsible?"":"collapse"} href={"#"+this.props.name}>
                <SmallTableHeader name={this.props.displayName}>
                </SmallTableHeader>

              </div>
              { this.props.datefilter && !this.props.end_date &&
                  <div>
                    Date :  
                    <DatePicker selected={this.state.selectedDate} className="select_date" onSelect={this.handleDateChange}/>
                  </div>
              }

              { this.props.end_date && 
                <div>
                  <div>
                  <div style={{flexDirection:'row'}}>
                    <span>Start Date:</span>
                    <span style={{paddingLeft:100}}>End Date:</span>
                  </div>
          
                    <DatePicker selected={this.state.selectedDate} className="select_date" onSelect={this.handleDateChange}/>
                     
                    <DatePicker selected={this.state.end_date} className="select_date" onSelect={this.handleEndDateChange}/>
                  
                  </div>
                  
                </div>
              }
              <div className="big-table-buttons">
                <CSVLink data={csvData} ><i className="fa fa-floppy-o" aria-hidden="true"></i></CSVLink>
                <a href='javascript:void(0)' onClick={this.refreshTable} ><i className="fa fa-refresh" aria-hidden="true"></i></a>

              </div>
            </div>
            <div id={this.props.name} className={this.props.nonCollapsible?"":"collapse"}>
              {this.bigTable(data,headers,this.props.name)}
            </div>
          </div>
        }
        { !this.props.bigTable &&
          this.smallTable(data,headers,this.props.name, this.props.displayName, this.props.color)
        }

      </WorkProgressPanel>
    );
  }
}


export default StatsTable


// WEBPACK FOOTER //
// ./src/app/components/statsTable/StatsTable.js